<div
  class="kwikui-toaster-container"
  *ngIf="toasterService.showToaster | async as isToasterVisible"
  [class.type-error]="toasterService.type === 'error'"
  [class.type-info]="!toasterService.type || toasterService.type === 'info'"
  [class.type-success]="toasterService.type === 'success'"
  [class.type-warning]="toasterService.type === 'warning'"
  [class.position-top-left]="
    toasterService.position === 'top-left' &&
    !toasterService.customPositionStyles
  "
  [class.position-top-center]="
    toasterService.position === 'top-center' &&
    !toasterService.customPositionStyles
  "
  [class.position-top-right]="
    toasterService.position === 'top-right' &&
    !toasterService.customPositionStyles
  "
  [class.position-center-left]="
    toasterService.position === 'center-left' &&
    !toasterService.customPositionStyles
  "
  [class.position-center-center]="
    toasterService.position === 'center-center' &&
    !toasterService.customPositionStyles
  "
  [class.position-center-right]="
    toasterService.position === 'center-right' &&
    !toasterService.customPositionStyles
  "
  [class.position-bottom-left]="
    toasterService.position === 'bottom-left' &&
    !toasterService.customPositionStyles
  "
  [class.position-bottom-center]="
    toasterService.position === 'bottom-center' &&
    !toasterService.customPositionStyles
  "
  [class.position-bottom-right]="
    toasterService.position === 'bottom-right' &&
    !toasterService.customPositionStyles
  "
  [class.shape-curved]="toasterService.shape === 'curved'"
  [class.shape-rectangle]="toasterService.shape === 'rectangle'"
  [class.shape-rounded]="toasterService.shape === 'rounded'"
  [class.size-xs]="toasterService.size === 'xs'"
  [class.size-s]="toasterService.size === 's'"
  [class.size-m]="toasterService.size === 'm'"
  [class.size-l]="toasterService.size === 'l'"
  [class.size-xl]="toasterService.size === 'xl'"
  [class.custom-positioned]="toasterService.customPositionStyles"
  [ngStyle]="toasterService.customPositionStyles || {}"
  [@panelInOut]="{
    value: isToasterVisible ? 'visible' : 'hidden',
    params: getAnimationParams()
  }"
  role="alert"
  [attr.aria-live]="toasterService.type === 'error' ? 'assertive' : 'polite'"
  tabindex="0"
  (click)="toasterService.hide()"
  (keydown.escape)="toasterService.hide()"
>
  <div class="toaster-content">
    <!-- Info icon -->
    <tui-svg
      [src]="toasterService.customIcons.info || 'tuiIconInfo'"
      class="toaster-icon toaster-icon-info"
      *ngIf="toasterService.type === 'info' || !toasterService.type"
    ></tui-svg>

    <!-- Warning icon -->
    <tui-svg
      [src]="toasterService.customIcons.warning || 'tuiIconAlertTriangle'"
      class="toaster-icon toaster-icon-warning"
      *ngIf="toasterService.type === 'warning'"
    ></tui-svg>

    <!-- Success icon -->
    <tui-svg
      [src]="toasterService.customIcons.success || 'tuiIconCheckCircle'"
      class="toaster-icon toaster-icon-success"
      *ngIf="toasterService.type === 'success'"
    ></tui-svg>

    <!-- Error icon -->
    <tui-svg
      [src]="toasterService.customIcons.error || 'tuiIconXCircle'"
      class="toaster-icon toaster-icon-error"
      *ngIf="toasterService.type === 'error'"
    ></tui-svg>
    <div class="toaster-message">
      {{ toasterService.message }}
    </div>
  </div>
</div>
